/**
 * WorkDocFontSize — Font size selector (8-72pt) with custom input option
 */
import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

const SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 42, 48, 60, 72];

export default function WorkDocFontSize({ value = "12pt", onChange, editor }) {
  const [isCustom, setIsCustom] = useState(false);
  const [customVal, setCustomVal] = useState(value?.replace("pt", "") || "12");

  const handleSizeChange = (val) => {
    if (val === "custom") {
      setIsCustom(true);
      return;
    }
    setIsCustom(false);
    const pts = `${val}pt`;
    if (editor) {
      editor.chain().focus().setMark("textStyle", { fontSize: pts }).run();
    }
    if (onChange) onChange(pts);
  };

  const handleCustomSubmit = () => {
    const num = parseInt(customVal);
    if (isNaN(num) || num < 1 || num > 200) return;
    const pts = `${num}pt`;
    if (editor) {
      editor.chain().focus().setMark("textStyle", { fontSize: pts }).run();
    }
    if (onChange) onChange(pts);
    setIsCustom(false);
  };

  if (isCustom) {
    return (
      <div className="flex items-center gap-1">
        <Input
          type="number"
          min={1}
          max={200}
          value={customVal}
          onChange={(e) => setCustomVal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleCustomSubmit()}
          onBlur={handleCustomSubmit}
          className="w-16 h-8 text-xs bg-gray-900 border-gray-700 text-white rounded"
          autoFocus
        />
        <span className="text-xs text-gray-400">pt</span>
      </div>
    );
  }

  return (
    <Select value={value?.replace("pt", "") || "12"} onValueChange={handleSizeChange}>
      <SelectTrigger className="w-20 h-8 text-xs bg-gray-900 border-gray-700 text-white rounded">
        <SelectValue placeholder="Size" />
      </SelectTrigger>
      <SelectContent className="bg-gray-900 border-gray-700 text-white max-h-52">
        {SIZES.map((s) => (
          <SelectItem key={s} value={String(s)} className="text-sm">
            {s}pt
          </SelectItem>
        ))}
        <SelectItem value="custom" className="text-xs text-blue-400 border-t border-gray-700 mt-1">
          Custom...
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
